import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewEncapsulation, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { take } from 'rxjs';
import { StoryblokService } from '../../../services/storyblok.service';
import { NotFoundComponent } from '../../../shared/components/not-found/not-found.component';
import { WebsiteFooterComponent } from '../../../shared/components/website-footer/website-footer.component';
import { WebsiteHeaderComponent } from '../../../shared/components/website-header/website-header.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokCta, StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { PreFooterComponent } from '../pre-footer/pre-footer.component';
import { ScrollProgressIndicatorComponent } from '../scroll-progress-indicator/scroll-progress-indicator.component';
import { TopGradientComponent } from '../top-gradient/top-gradient.component';

@Component({
  selector: 'app-storyblok-root',
  standalone: true,
  imports: [
    StoryblokDirective,
    DynamicComponent,
    DynamicIoDirective,
    WebsiteHeaderComponent,
    PreFooterComponent,
    RouterLink,
    ButtonDirective,
    WebsiteFooterComponent,
    NotFoundComponent,
    TopGradientComponent,
    StoryblokCdnPipe,
    ScrollProgressIndicatorComponent,
  ],
  templateUrl: './storyblok-root.component.html',
  styleUrls: ['./storyblok-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class StoryblokRootComponent implements OnChanges {
  private route = inject(ActivatedRoute);
  public storyblokService = inject(StoryblokService);
  @Input({ required: true }) story: ISbStoryData;
  @Input({ required: true }) darkHeader: boolean;
  @Input({ required: true }) prefooter: {
    cta: StoryblokCta[];
    _uid: string;
    image: StoryblokImage;
    component: 'preFooter';
    _editable: string;
  };
  @Input({ required: true }) hasHomeTeaser: boolean;
  @Input({ required: true }) blurOverlay: StoryblokImage;
  @Input({ required: true }) topBlur: StoryblokImage;
  @Input({ required: true }) verticalDottedLines: boolean;
  @Input() extraDataMap: Map<string, { [key: string]: unknown }>;
  @Input() hideHeaderNav: boolean;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() customCta: 'contact' | undefined;

  allowSticky = signal<boolean>(undefined);

  ngOnChanges(): void {
    if (!this.story?.content?.body) return;
    this.storyblokService
      .getUniqueComponentsList(this.route.snapshot)
      .pipe(take(1))
      .subscribe(components => {
        this.allowSticky.set(!components.has('ProductComparisonList'));
      });
  }

  dynamicInputs(values: { [key: string]: unknown }) {
    const data = { ...values };
    const extraData = this.extraDataMap?.get((values as { component: string }).component);
    if (extraData) {
      for (const key of Object.keys(extraData)) data[key] = extraData[key];
    }
    return data;
  }
}
